import moment from "moment";

import { IActData } from "./hooks/useCreateKs2";

export const initialCreateKsData = {
  dateEnd: moment().format("YYYY-MM-DD"),
  dateStart: moment().format("YYYY-MM-DD"),
} as IActData;

export const JOURNAL_ACTING_ROW_GRIDS = {
  EXPENDITURE_IN_ESTIMATE: [3, 29, 8, 6.1, 6.1, 6.2, 14.5, 14, 13.1],
  EXPENDITURE_IN_GROUPED_BY_KS2: [3, 30.5, 14.0, 7.8, 7.8, 7.8, 14, 14],
  MODAL_EXPENDITURE: [4, 46, 10, 20, 20],
  MODAL_KS2_EXPENDITURE: [6, 35, 10, 22, 22, 3], // 20
};
